import b_ from 'b_';

export const b = b_.with('showcase-lesson-card');
